document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.getElementById("drawer-cart");
  const weglot = document.getElementById("lang-switcher-desktop");

  if (drawer && weglot) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          const isVisible = drawer.classList.contains("drawer--visible");
          if (isVisible) {
            hideMobileSticky();
            weglot.style.setProperty('display', 'none', 'important');
          } else {
            showMobileSticky()
            weglot.style.setProperty('display', 'flex', 'important');
          }
        }
      });
    });

    observer.observe(drawer, { attributes: true });
  }
});

document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    //console.log(event.detail);
    if (cart) {
        //console.log('Cart ———————————— ↓');
        //console.log(cart);
        let data = cart.items.map((item, i) => ({...item, variant_id:i}));
        refreshShippingCosts(data);
        refresPromotionCosts(data);
    }
    //Movemos barra mensaje promocion
    $('#sca-promotion-message-layout').insertBefore('#text_offer_bar1');
    $('#sca-promotion-message-layout').css('margin-bottom', '10px');
});

document.addEventListener('custom:cart:productAdded', function(event) {
  setTimeout(() => {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (!$('#drawer-cart').hasClass('drawer--visible')) {
          const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');

          document.dispatchEvent(
            new CustomEvent('theme:cart:change', {
              detail: {
                cart: cart,
              },
              bubbles: true,
            })
          );

          cartDrawer.dispatchEvent(
            new CustomEvent('theme:drawer:open', {
              bubbles: false,
            })
          );
        }
      });
  }, 1000);
});



function refreshShippingCosts(data) {
    //Calculamos si cobraremos gastos de envío
    var total_price = 0;
    var subscription = false;
    $.each(data,function(index, item){
        total_price += item.final_line_price;
        if(item.selling_plan_allocation)
            subscription = true;
    });
    var total_decimal = total_price/100;
    var diff = (45 - total_decimal).toFixed(2);

    if (diff >= 45) {
        porcentaje = 0;
    } else if (diff <= 0) {
        porcentaje = 100;
    } else {
        porcentaje = ((45 - diff) / 45) * 100;
    }

    //Modificamos texto y barra de envío según condiciones
    if(diff > 0 && subscription == false)
    {
        $('#progress_shipping_bar').replaceWith('<div id="progress_shipping_bar" style="margin-bottom:15px; background:rgba(202, 170, 141, 0.35);" class="mu-progress-bar-container mu-flex mu-w-full mu-relative mu-mix-blend-darken mu-h-2 mu-rounded-2" style="background: rgba(202, 170, 141, 0.35);"><div class="mu-progress-bar mu-block mu-transition-width mu-absolute mu-inset-0 mu-duration-500 mu-ease-out mu-z-10 mu-h-2 mu-rounded-2" style="background: rgb(66, 33, 11); width: ' + porcentaje + '%;"></div><div class="mu-badge-goal mu-relative mu-flex-1 mu-bg-transparent mu-z-20 mu-mix-blend-overlay mu-h-2 mu-rounded-l-2 mu-rounded-r-2" style="border-color: rgb(113, 128, 150); display: block;"></div></div>');
        $('#text_shipping_bar').replaceWith('<div id="text_shipping_bar" class="mu-goal-shipping-text mu-w-full"><div class="mu-emoji-image mu-mb-0 mu-text-center"><p class="ql-align-center">¡Quedan <span id="txtFreeShipping"></span> € para conseguir gastos de envío gratis!</p></div></div>');
        $('#txtFreeShipping').text(diff.toString().replace('.', ',')); 
    }
    else{
        $('#progress_shipping_bar').replaceWith('<div id="progress_shipping_bar" style="margin-bottom:15px;" class="mu-progress-bar-container mu-flex mu-w-full mu-relative mu-mix-blend-darken mu-h-2 mu-rounded-2" style="background: rgba(202, 170, 141, 0.35);"><div class="mu-progress-bar mu-block mu-transition-width mu-absolute mu-inset-0 mu-duration-500 mu-ease-out mu-z-10 mu-h-2 mu-rounded-2" style="background: rgb(178, 135, 94); width: 100%;"></div><div class="mu-badge-goal mu-relative mu-flex-1 mu-bg-transparent mu-z-20 mu-mix-blend-overlay mu-h-2 mu-rounded-l-2 mu-rounded-r-2" style="border-color: rgb(113, 128, 150); display: block;"></div></div>');
        $('#text_shipping_bar').replaceWith('<div id="text_shipping_bar" class="mu-goal-shipping-text mu-w-full"><div class="mu-emoji-image mu-mb-0 mu-text-center"><p class="ql-align-center">¡Gastos de envío gratis!</p></div></div>');
    }
}

function refresPromotionCosts(data) {
    var total_price = 0;
    var total_promotion = 0;
    var name_promotion = '';
    var image_promotion = '';
    var gift_added = false;
    total_promotion = $('#priceoffer1').text();
    name_promotion = $('#nameoffer1').text();
    image_promotion = $('#imageoffer1').text();

    if (!isNaN(total_promotion)) {
        $.each(data,function(index, item){
            total_price += item.final_line_price;
        });

        var total_decimal = total_price/100;
        var diff = (total_promotion - total_decimal).toFixed(2);

        if (diff >= total_promotion) {
            porcentaje = 0;
        } else if (diff <= 0) {
            porcentaje = 100;
        } else {
            porcentaje = ((total_promotion - diff) / total_promotion) * 100;
        }

        //Modificamos barra progreso oferta
        if(diff > 0)
        {
            $('.mu-progress-bar-container').show();
            $('#progress_offer_bar').replaceWith('<div id="progress_offer_bar" style="margin-bottom:15px; background:rgba(202, 170, 141, 0.35);" class="mu-progress-bar-container mu-flex mu-w-full mu-relative mu-mix-blend-darken mu-h-2 mu-rounded-2" style="background: rgba(202, 170, 141, 0.35);"><div class="mu-progress-bar mu-block mu-transition-width mu-absolute mu-inset-0 mu-duration-500 mu-ease-out mu-z-10 mu-h-2 mu-rounded-2" style="background: rgb(66, 33, 11); width: ' + porcentaje + '%;"></div><div class="mu-badge-goal mu-relative mu-flex-1 mu-bg-transparent mu-z-20 mu-mix-blend-overlay mu-h-2 mu-rounded-l-2 mu-rounded-r-2" style="border-color: rgb(113, 128, 150); display: block;"></div></div>');
            $('#text_offer_bar1').replaceWith('<p id="text_offer_bar1">¡Quedan <span id="txtFreeGift1"></span> € para conseguir la ' + name_promotion + '!</p>');
            $('#text_offer_bar2').replaceWith('<p id="text_offer_bar2" class="ql-align-center">¡Quedan <span id="txtFreeGift2"></span> € para conseguir la ' + name_promotion + '!</p>');
            $('#txtFreeGift1').text(diff.toString().replace('.', ',')); 
            $('#txtFreeGift2').text(diff.toString().replace('.', ',')); 
            $('.mu-progress-bar-container').show();
            $('#namepromotion').text(name_promotion); 
            $('#namepromotion').text(function(_, currentText) {
                return currentText.charAt(0).toUpperCase() + currentText.slice(1);
            });
            $('#imagepromotion').css('background-image', 'url("' + image_promotion + '")');
            $('.mu-free-gift').show();
            $('.mu-text-center').css('border-color', 'rgb(202, 170, 141)');
            $('#cartpromotion').show();
        }
        else{
            checkGiftInCart().then(gift_added => {
                if (gift_added) {
                    $('#progress_offer_bar').replaceWith('<div id="progress_offer_bar"></div>');
                    $('#text_offer_bar1').replaceWith('<p id="text_offer_bar1">¡Hemos añadido el regalo!</p>');
                    $('#text_offer_bar2').replaceWith('<p id="text_offer_bar2" class="ql-align-center">¡Hemos añadido el regalo!</p>');
                    $('.mu-progress-bar-container').eq(1).hide();
                    $('#namepromotion').text(name_promotion); 
                    $('#namepromotion').text(function(_, currentText) {
                        return currentText.charAt(0).toUpperCase() + currentText.slice(1);
                    });
                    $('#imagepromotion').css('background-image', 'url("' + image_promotion + '")');
                    $('.mu-free-gift').hide();
                    $('.mu-text-center').css('border-color', 'transparent');
                    $('#cartpromotion').show();
                } else {
                    //No tenemos activa ninguna suscripción
                    $('#cartpromotion').hide();
                }
            });
        }
    }
}

async function checkGiftInCart() {
    let gift_added = false;

    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        if (cart.items.length > 0) {
            $.each(cart.items, function(index, item) {
                if (item.final_line_price == "0")
                    gift_added = true;
            });
        }
    } catch (error) {
        console.error("Error al obtener el carrito:", error);
    }

    return gift_added;
}



